// noinspection JSUnusedLocalSymbols,JSUnusedGlobalSymbols

import { Injectable } from '@angular/core';
import { Observable, Subscriber } from 'rxjs';
import { ApiService } from './api.service';
import { ServerResponse } from '../../interfaces/base/server.response';
import { ApiEndpointsService } from './api-endpoints.service';
import { HeadCategory } from '../../interfaces/routering/head-category';
import { SubCategory } from '../../interfaces/routering/sub-category';
import { IntegratedOptions } from '../../interfaces/base/integrated-options';

@Injectable()

export class FiltersService {

  public filters: any = null;

  private filterData: any = {
    headCategories: [],
    subCategories: [],
  };


  constructor(private api: ApiService,
              private apiEndpoints: ApiEndpointsService,
  ) {
  }

  yesNo(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Ja',
          id: true
        },
        {
          name: 'Nee',
          id: false
        }
      ]);
    });
  }

  personPrefix(): Observable<IntegratedOptions[]> {
    return new Observable<IntegratedOptions[]>((o: Subscriber<IntegratedOptions[]>): void => {
      o.next([
        {
          name: 'Heer',
          id: 'Heer'
        },
        {
          name: 'Mevrouw',
          id: 'Mevrouw'
        },
        {
          name: 'Neutraal',
          id: 'Neutraal',
        }
      ]);
    });
  }

  headCategories(): Observable<HeadCategory[] | boolean> {
    return new Observable<HeadCategory[]>((o: Subscriber<HeadCategory[] | boolean>): void => {
      // check if we have cached data available
      if (this.filterData.headCategories.length) {
        o.next(this.filterData.headCategories);
      } else {
        // get data from server
        if (this.filters !== null) {
          if (typeof this.filters.headCategories !== 'undefined') {
            this.filters.headCategories.isLoading = true;
          }
        }

        this.api.get(this.apiEndpoints.get('webform.head-categories')).subscribe(
          (response: ServerResponse): void => {
            if (this.filters !== null) {
              if (typeof this.filters.headCategories !== 'undefined') {
                this.filters.headCategories.isLoading = false;
              }
            }

            if (typeof response.data !== 'undefined') {
              o.next(response.data);
              this.filterData.headCategories = response.data;
            } else {
              o.next(false);
            }
          },
          (): void => {
            if (this.filters !== null) {
              if (typeof this.filters.headCategories !== 'undefined') {
                this.filters.headCategories.isLoading = false;
              }
            }

            o.next(false);
          });
      }
    });
  }

  subCategories(id: number): Observable<SubCategory[] | boolean> {
    return new Observable<SubCategory[]>((o: Subscriber<SubCategory[] | boolean>): void => {
      if (typeof this.filterData.subCategories[id] !== 'undefined' && this.filterData.subCategories[id].length) {
        o.next(this.filterData.subCategories[id]);
      } else {
        // get data from server
        if (this.filters !== null) {
          if (typeof this.filters.subCategories !== 'undefined') {
            this.filters.subCategories.isLoading = true;
          }
        }

        this.api.get(this.apiEndpoints.get('webform.head-categories.sub-categories', {':id': id})).subscribe(
          (response: ServerResponse): void => {
            if (this.filters !== null) {
              if (typeof this.filters.subCategories !== 'undefined') {
                this.filters.subCategories.isLoading = false;
              }
            }

            if (typeof response.data !== 'undefined') {
              o.next(response.data);
              this.filterData.subCategories[id] = response.data;
            } else {
              o.next(false);
            }
          },
          (): void => {
            if (this.filters !== null) {
              if (typeof this.filters.subCategories !== 'undefined') {
                this.filters.subCategories.isLoading = false;
              }
            }

            o.next(false);
          });
      }
    });
  }
}
